import React from 'react';
import { FaArrowCircleLeft } from "react-icons/fa";
import { Link, useNavigate } from 'react-router-dom';
import { TimeZone } from '../../components/TimeZone';

export default () => {
  return (
    <div>
<section className="select-det detail-sec">
  <div className="container py-4 py-md-5 px-2">
    <div className="row px-1 px-sm-5">
      {/* ========col-1====== */}
      <div className=" col-xl-1 mt-3 ">
          <Link to={"/agency-packages"}>
          <FaArrowCircleLeft size={32}/>
          </Link>
      </div>
      {/* ========col-2====== */}
      <div className="col-12 col-xl-10 select-det-main rounded-3 bg-white mt-3 mt-xl-0 position-relative power-calendly">
        {/* <div className="position-absolute powered d-none d-sm-block">
          <p className="text-uppercase text-left  fw-normal">powered by</p>
          <p className="fs-6 fw-bold mt-1">Calendly</p>
        </div> */}
        <div className="row">
          {/* ========col-2::a ====== */}
          <div className="col-lg-4 border-end py-4 px-4 text-center text-lg-start">
            <h6 className="text-secondary fw-bolder">Mark Letteriello</h6>
            <h3 className="mt-2 fw-bolder">Rolling Adz</h3>
            <div className="d-flex align-items-center justify-content-center justify-content-lg-start mt-4">
              <i className="fas fa-clock me-2" />
              <span className="fw-bolder text-secondary">30 min</span>
            </div>
            <div className="d-flex align-items-center justify-content-center justify-content-lg-start mt-2">
              <i className="fas fa-map-marker-alt me-2" />
              <span className="text-secondary fw-bolder text-break bs-lh">http://us02web.zoom.us/j/6982318908</span>
            </div>
            <p className="bs-lh mt-4">Mark Letteriello is inviting you to a scheduled Zoom meeting.</p>
            <p className="bs-lh mt-4">Topic:Mark Letteriello's Personal Meeting Room</p>
            <p className="bs-lh mt-4">Join Zoom meeting
              <a href="#" className="d-block mt-2 text-break bs-lh">http://us02web.zoom.us/j/6982318908</a>
            </p>
            <p className="bs-lh mt-4"> Meeting ID 698 231 8908</p>
            <p className="bs-lh mt-2">One tap mobile</p>
            <p className="bs-lh mt-2">+12532158782,,6982318908# US(Tacoma)</p>
            <p className="bs-lh mt-2">+13462458782,,6982318908# US(Houtom)</p>
            <p className="bs-lh mt-4">Dial by your locaation</p>
            <p className="bs-lh mt-2">+1 2532158782 US(Tacoma)</p>
            <p className="bs-lh mt-1">+1 3462458782 US(Houtom)</p>
            <a href="#" className="d-block mt-4">Cookie settings</a>
          </div>
          {/* ========col-2::b ====== */}
          <div className="col-lg-8">
            <div className="row">
              {/* ========col-2::b:::(i) ====== */}
              <section className=" my-cal col-md-12 col-lg-12 py-4" >
                <h4 className="fw-bolder ms-3 text-center text-lg-start">Select a Date &amp; Time</h4>
              <div className='py-2 mt-5'>
                <div className="container mt-5">
                  <label className='p-2 fw-bold' htmlFor="time">Select Time</label>
                  <input className='form-control' type="time" name="" id="time" />
                  <div className='mt-2'>
                  <label className='p-2 fw-bold' htmlFor="Date">Select Date</label>
                  <input className='form-control' type="date" name="" id="Date" />
                  </div>
                </div>
                {/* -------Time Zone------ */}
                <div className="px-3 mt-4">
                  <h6 className="fw-bolder text-center text-md-start">Time zone</h6>
                  <div className="">
                   <TimeZone/>
                  </div>
                </div>
                <div className='d-flex justify-content-center p-3 '>
                <Link to={"/schedule-event"}>
                <button className='btn btn-primary px-5'>
                  save
                </button>
                </Link>
                </div>
              </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

    </div>
  )
}
